// extracted by mini-css-extract-plugin
export default {"container":"j8-z","title":"k8-z","link":"l8-z"};